import React, { Component } from "react";
import styles from "./reportContructor.module.scss";
import { withReportsList } from "../../../shared/containers/containerReportsList";
import { withCustomReport } from "../../../shared/containers/containerCustomReport";
import SaveIcon from "@mui/icons-material/Save";
import TooltipWrapper from "../../../shared/items/contols/tooltipWrapper";

class ReportFieldsConstructorItem extends Component {
  constructor(props) {
    super(props);
    this.state = { title: props.title };
  }

  onSelectToChange() {
    const { field, onSelectHandle } = this.props;
    onSelectHandle(field);
  }

  onUpdate() {
    const { onUpdateHandler } = this.props;

    onUpdateHandler();
  }

  render() {
    const { field, isSelect, cssColumnWidth } = this.props;

    return (
      <TooltipWrapper title={`Кликните для редакитрования`} position="top">
        <div
          style={{ width: `${cssColumnWidth}px` }}
          className={styles.fieldContainer}
          onClick={(e) => {
            e.stopPropagation();
            this.onSelectToChange();
          }}
        >
          {isSelect ? (
            <TooltipWrapper title={`Сохранить`} position="top">
              <SaveIcon
                fontSize="small"
                onClick={(e) => {
                  e.stopPropagation();
                  this.onUpdate();
                }}
              />
            </TooltipWrapper>
          ) : null}
          <div>
            {field.dashboard.title} {field.dashboard.measure != null ? `(${field.dashboard.measure})` : null}
          </div>
        </div>
      </TooltipWrapper>
    );
  }
}

export default withCustomReport(withReportsList(React.memo(ReportFieldsConstructorItem)));
